module.exports = __webpack_public_path__ + "media/stylesheets/images/rausi_krossinn_32x32-b58cfa255be830a89080b2ab53c777dc.ico";